import React from 'react';
import '../css/Footer.css';
import visaLogo from '../assets/visa.jpeg';
import mastercardLogo from '../assets/MasterCard.png';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-links">
                <a href="/terms">Terms & Conditions</a> |
                <a href="/privacy"> Privacy Policy</a> |
                <a href="/refund"> Refund Policy</a> |
                <a href="/about"> About Us</a> |
                <a href="/faq"> FAQ</a> |
                <span className="site-name"> PrettyLoveColombo</span> © All Rights Reserved - 2026
            </div>
            {/* <div className="footer-payment">
                <img src={visaLogo} alt="Visa" className="payment-icon" />
                <img src={mastercardLogo} alt="MasterCard" className="payment-icon" />
            </div> */}
        </footer>
    );
}

export default Footer;
